const aaa = [
  
    // 线上退货订单
    {
        path: "onlineReturnList",
        component: () => import("@/views/dingdan/order/onlineReturn/list.vue"),
        meta: { title: '订单', keepAlive: false },
    },
    {
        path: "onlineReturnSee",
        component: () => import("@/views/dingdan/order/onlineReturn/see.vue"),
        meta: { title: '订单' },
    },

    
]
export default aaa;